import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import Collapse from 'react-collapse';
import { Point as PointDefault } from './Point';
import { Points as LayoutDefault } from './Points';
class PointsContainer extends PureComponent {
  static propTypes = {
    points: PropTypes.array.isRequired,
    Layout: PropTypes.func,
    Point: PropTypes.func,
    visibleSidePointsCount: PropTypes.number,
    minHiddenPointsCount: PropTypes.number,
    hasManySegments: PropTypes.bool,
    tripSegmentsIdx: PropTypes.number,
    /** Флаг, разворачивается ли список точек */isExpandable: PropTypes.bool,
    pointProps: PropTypes.object,
    timeInRoad: PropTypes.node,
    isToggleHidden: PropTypes.bool,
    isPreviewDetails: PropTypes.bool
  };
  static defaultProps = {
    visibleSidePointsCount: 1,
    minHiddenPointsCount: 3,
    Point: PointDefault,
    Layout: LayoutDefault,
    pointProps: {}
  };
  state = {
    expanded: false,
    topPoints: [],
    hiddenPoints: [],
    bottomPoints: [],
    transferPoints: [],
    hiddenPointsCount: 0,
    hiddenTransfersCount: 0
  };
  UNSAFE_componentWillMount() {
    this.updatePoints(this.props);
    this.updateExpandable(this.props);
  }
  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      points,
      visibleSidePointsCount,
      isExpandable,
      minHiddenPointsCount
    } = this.props;
    const {
      points: newPoints,
      visibleSidePointsCount: newVisibleSidePointsCount,
      isExpandable: newIsExpandable,
      minHiddenPointsCount: newMinHiddenPointsCount
    } = newProps;
    if (points !== newPoints || newVisibleSidePointsCount !== visibleSidePointsCount) {
      this.updatePoints(newProps);
    }
    if (isExpandable !== newIsExpandable || minHiddenPointsCount !== newMinHiddenPointsCount) {
      this.updateExpandable(newProps);
    }
  }
  onToggle = e => {
    e.stopPropagation();
    this.setState({
      expanded: !this.state.expanded
    });
  };
  updatePoints({
    points,
    visibleSidePointsCount
  }) {
    const {
      hasManySegments,
      minHiddenPointsCount
    } = this.props;
    const isPointsHasTransfer = points.some(point => point.isTransferPoint);
    const pointsCount = points.length;
    let hiddenPoints = [];
    let transferPoints = [];
    let hiddenTransfersCount = 0;
    if (pointsCount - visibleSidePointsCount * 2 > 0) {
      hiddenPoints = points.slice(visibleSidePointsCount, pointsCount - visibleSidePointsCount);
      hiddenTransfersCount = hiddenPoints.reduce((total, {
        isTransferPoint
      }) => isTransferPoint ? total + 1 : total, 0);
    }
    if (!hasManySegments && isPointsHasTransfer && hiddenPoints.length >= minHiddenPointsCount) {
      transferPoints = points.filter(point => point.isTransferPoint);
    }
    this.setState({
      topPoints: points.slice(0, visibleSidePointsCount),
      hiddenPoints,
      bottomPoints: points.slice(pointsCount - visibleSidePointsCount),
      transferPoints,
      hiddenPointsCount: hiddenPoints.length,
      hiddenTransfersCount,
      expanded: hiddenPoints.length < minHiddenPointsCount
    });
  }
  updateExpandable() {
    this.setState(({
      hiddenPoints
    }, {
      isExpandable,
      minHiddenPointsCount
    }) => ({
      isExpandable: isExpandable && hiddenPoints.length >= minHiddenPointsCount
    }));
  }
  renderPoints(pointsPart) {
    const {
      points,
      Point,
      pointProps,
      hasManySegments,
      tripSegmentsIdx
    } = this.props;
    const {
      expanded
    } = this.state;
    const firstPoint = points[0];
    const lastPoint = points[points.length - 1];
    return pointsPart.map((point, index) => /*#__PURE__*/React.createElement(Point, {
      // eslint-disable-next-line react/no-array-index-key
      key: index,
      ...pointProps,
      point: point,
      isFirst: firstPoint === point,
      isLast: lastPoint === point,
      hasManySegments: hasManySegments,
      tripSegmentsIdx: tripSegmentsIdx,
      expanded: expanded
    }));
  }
  renderCollapseComponent = () => {
    const {
      hiddenPoints
    } = this.state;
    return /*#__PURE__*/React.createElement(Collapse, {
      isOpened: true
    }, this.renderPoints(hiddenPoints));
  };
  render() {
    const {
      points
    } = this.props;
    if (!points.length) {
      return null;
    }
    const {
      Layout,
      timeInRoad,
      isToggleHidden,
      hasManySegments,
      isPreviewDetails
    } = this.props;
    const {
      expanded,
      topPoints,
      hiddenPoints,
      bottomPoints,
      transferPoints,
      isExpandable,
      hiddenPointsCount,
      hiddenTransfersCount
    } = this.state;
    const collapsedHiddenPoints = isExpandable ? this.renderCollapseComponent() : this.renderPoints(hiddenPoints);
    return /*#__PURE__*/React.createElement(Layout, {
      topPoints: this.renderPoints(topPoints),
      hiddenPoints: collapsedHiddenPoints,
      bottomPoints: this.renderPoints(bottomPoints),
      transferPoints: this.renderPoints(transferPoints),
      isExpandButtonShown: isExpandable && !expanded,
      isCollapseButtonShown: isExpandable && expanded,
      onToggle: this.onToggle,
      hiddenPointsCount: hiddenPointsCount,
      hiddenTransfersCount: hiddenTransfersCount,
      timeInRoad: timeInRoad,
      isToggleHidden: isToggleHidden,
      hasManySegments: hasManySegments,
      isPreviewDetails: isPreviewDetails,
      isExpanded: expanded
    });
  }
}
export default PointsContainer;